import { z } from "zod";

import { createPaginatedResponseSchema } from "../api/pagination";

import { type UserProfilePreview, UserProfilePreviewSchema } from "./preview";

export type UserRelationship = {
  id: string;
  rank: number;
  profile: UserProfilePreview;
};

export enum RelationshipType {
  FOLLOWING = "FOLLOWING",
  FOLLOWER = "FOLLOWER",
}

export const UserRelationshipSchema = z.object({
  id: z.string(),
  profile: UserProfilePreviewSchema,
  rank: z.number(),
});

export const RelationshipResponseSchema = createPaginatedResponseSchema(
  UserRelationshipSchema,
);

export type FollowingType = UserRelationship;
export type FollowerType = UserRelationship;
